export default __webpack_public_path__ + "static/media/tex4.5dd1cad1.jpg";